module.exports = __webpack_public_path__ + "img/time-management.7640a941.png";